import React, { useState, useContext } from 'react';
import AuthContext, { AuthProvider } from '../context/AuthContext'; // Assuming AuthContext provides user info

export default function ScoutingReportForm() {
  let { user } = useContext(AuthContext);


  const generateRandomId = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let id = '';
  for (let i = 0; i < 10; i++) {
    id += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return id;
};

  const randomId = generateRandomId();
  const districts = [
    { value: 'tema_metropolitan', label: 'Tema Metropolitan', zone: 'Zone A' },
    { value: 'tema_west', label: 'Tema West', zone: 'Zone A' },
    { value: 'tema_central', label: 'Tema Central', zone: 'Zone A' },
    { value: 'ashaiman', label: 'Ashaiman', zone: 'Zone A' },
    { value: 'kpone_katamanso', label: 'Kpone-Katamanso', zone: 'Zone A' },
    { value: 'ada_east', label: 'Ada East', zone: 'Zone B' },
    { value: 'ningo_prampram', label: 'Ningo-Prampram', zone: 'Zone B' },
    { value: 'shai_osudoku', label: 'Shai-Osudoku', zone: 'Zone B' },
    { value: 'ada_west', label: 'Ada West', zone: 'Zone B' },
    { value: 'adentan', label: 'Adentan', zone: 'Zone C' },
    { value: 'la_dade_kotopon', label: 'La Dade-Kotopon', zone: 'Zone C' },
    { value: 'ledzokuku', label: 'Ledzokuku', zone: 'Zone C' },
    { value: 'krowor', label: 'Krowor', zone: 'Zone C' },
    { value: 'weija_gbawe', label: 'Weija Gbawe', zone: 'Zone C' },
  ];

  const weeks = ['1', '2', '3'];

  const [form, setForm] = useState({
    volunteer_id: user ? user.username : '', // Matches Django model field name
    zone: '',
    district: '',
    report_date: '', // Matches Django model field name
    reporting_week: '', // Matches Django model field name
    communities_visited: '',
    stakeholders_engaged: '',
    community_feedback: '',
    number_of_innovators: '',
    innovations: '',
    volunteer: user ? user.username : '', // Matches Django model field name, assuming it's the same as volunteer_name
    male_innovators_count: '',
    male_innovators_validated: '',
    male_innovators_notes: '',
    female_innovators_count: '',
    female_innovators_validated: '',
    female_innovators_notes: '',
    pwd_innovators_count: '',
    pwd_innovators_validated: '',
    pwd_innovators_notes: '',
    challenges_encountered: '',
    suggestions_recommendations: '',
    learnings_reflections: '',
     // Unique report ID
  });

  const [message, setMessage] = useState(''); // State for success/error messages

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === 'file') {
      setForm((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setForm((prev) => {
        const newState = { ...prev, [name]: value };

        // If the changed field is district, update the zone automatically
        if (name === 'district') {
          const selectedDistrict = districts.find(d => d.value === value);
          if (selectedDistrict) {
            newState.zone = selectedDistrict.zone;
          } else {
            newState.zone = ''; // Clear zone if no district is selected
          }
        }
        return newState;
      });
    }
  };

  const handleMetricChange = (category, field, value) => {
    // This function needs to update the flattened fields directly
    const fieldName = `${category}_innovators_${field}`; // e.g., male_innovators_count
    setForm((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('Submitting report...'); // Show loading message

    const formData = new FormData();
    formData.append('report_id', randomId);

    // Append all form fields to FormData
    for (const key in form) {
      if (form.hasOwnProperty(key)) {
        if (key === 'file' && form[key]) {
          formData.append(key, form[key]);
        } else if (key !== 'scoutingMetrics') { // Exclude the old scoutingMetrics object
          formData.append(key, form[key]);
        }
      }
    }

    // Adjust date format for Django
    if (form.report_date) {
        formData.set('report_date', form.report_date);
    }
    
    // Ensure reporting_week is correctly formatted for Django
    if (form.reporting_week) {
        formData.set('reporting_week', form.reporting_week);
    }

    // Assuming your Django API endpoint is `/api/scouting-reports/`
    // You might need to adjust this URL based on your actual Django setup.
    // const API_URL = 'upload-scouting-report-form/'; 
    const api_link = 'https://api.mba-gris.stgafrica.org/upload-scouting-report-form/'
    // const api_link = 'http://localhost:8000/upload-scouting-report-form/'

    try {
      const response = await fetch(api_link, {
        method: 'POST',
        // When sending FormData, the 'Content-Type' header is automatically set
        // to 'multipart/form-data' by the browser, so don't set it manually.
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setMessage('Report submitted successfully!');
        window.location = '/select-scouting-report-type'; // Redirect to home page or another page after success
        // window.scrollTo(0, 0); // Scroll to the top to show the message
        // console.log('Success:', data);
        // Optionally, reset the form here
        // setForm({
        //     volunteer_name: user ? user.username : '',
        //     zone: '',
        //     district: '',
        //     report_date: '',
        //     reporting_week: '',
        //     communities_visited: '',
        //     stakeholders_engaged: '',
        //     community_feedback: '',
        //     number_of_innovators: '',
        //     innovations: '',
        //     file: null,
        //     innovator_phone: '',
        //     volunteer: user ? user.username : '',
        //     male_innovators_count: '',
        //     male_innovators_validated: '',
        //     male_innovators_notes: '',
        //     female_innovators_count: '',
        //     female_innovators_validated: '',
        //     female_innovators_notes: '',
        //     pwd_innovators_count: '',
        //     pwd_innovators_validated: '',
        //     pwd_innovators_notes: '',
        //     challenges_encountered: '',
        //     suggestions_recommendations: '',
        //     learnings_reflections: '',
        // });
      } else {
        const errorData = await response.json();
        setMessage(`Error submitting report: ${JSON.stringify(errorData)}`);
        console.error('Error:', errorData);
      }
    } catch (error) {
      setMessage(`Network error: ${error.message}`);
      console.error('Network error:', error);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        maxWidth: '960px', // max-w-4xl (approx 960px)
        margin: '40px auto', // mx-auto my-10
        paddingRight: '8px', // p-6
        paddingBottom: '16px',
        backgroundColor: '#fff', // bg-white
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', // shadow-xl
        borderRadius: '8px', // rounded-lg
        border: '1px solid #e2e8f0', // border border-gray-200
        display: 'flex',
        flexDirection: 'column',
        gap: '0px', // space-y-8
      }}
    >
      <h1
        style={{
          fontSize: '30px', // text-3xl
          fontWeight: '800', // font-extrabold
          textAlign: 'center', // text-center
          color: '#1a202c', // text-gray-900
        }}
      >
        Volunteer Field Report
      </h1>
      <div style={{ textAlign: 'center' }}>
        {/* Using a placeholder image as the original path might not exist in this environment */}
        <img src={require("../assets/images/mba-logo.png")} alt="Logo" style={{ width: '100px', height: 'auto' }} />
      </div>

      {message && (
        <div style={{
          padding: '12px',
          margin: '16px 0',
          borderRadius: '8px',
          backgroundColor: message.includes('Error') ? '#fee2e2' : '#d1fae5', // red-100 or green-100
          color: message.includes('Error') ? '#ef4444' : '#10b981', // red-500 or green-500
          textAlign: 'center',
          fontWeight: 'bold',
        }}>
          {message}
        </div>
      )}

      {/* Section 1: General Information */}
      <section
        style={{
          backgroundColor: '#f8fafc', // bg-gray-50
          padding: '24px', // p-6
          borderRadius: '8px', // rounded-lg
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)', // shadow-sm
          border: '1px solid #f1f5f9', // border border-gray-100
        }}
      >
        <h2
          style={{
            fontSize: '24px', // text-2xl
            fontWeight: '700', // font-bold
            color: '#2d3748', // text-gray-800
            marginBottom: '20px', // mb-5
            paddingBottom: '12px', // pb-3
            borderBottom: '1px solid #cbd5e0', // border-b border-gray-200
          }}
        >
          Section 1: General Information
        </h2>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr', // grid-cols-1
            gap: '24px', // gap-6
          }}
        >
          {/* Responsive adjustment for grid-cols-2 on medium screens */}
          <style jsx>{`
            @media (min-width: 768px) {
              section > div {
                grid-template-columns: repeat(2, 1fr);
              }
            }
          `}</style>
          <div>
            <label
              htmlFor="volunteer_id" // Changed name to match Django model
              style={{
                display: 'block',
                fontSize: '14px', // text-sm
                fontWeight: '500', // font-medium
                color: '#4a5568', // text-gray-700
                marginBottom: '4px', // mb-1
              }}
            >
              Unique Volunteer ID
            </label>
            <input
              id="volunteer_id"
              type="text"
              readOnly
              name="volunteer_id" // Changed name to match Django model
              placeholder="Enter volunteer's name"
              value={form.volunteer_id}
              onChange={handleChange}
              required
              style={{
                width: '100%', // w-full
                padding: '12px', // p-3
                border: '1px solid #cbd5e0', // border border-gray-300
                borderRadius: '6px', // rounded-md
                outline: 'none', // focus:outline-none (default browser outline)
                transition: 'border-color 0.15s ease-in-out', // transition duration-150 ease-in-out
              }}
              onFocus={(e) => (e.target.style.borderColor = '#3b82f6')} // blue-500
              onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')} // gray-300
            />
          </div>
          <div>
            <label
              htmlFor="district"
              style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4a5568',
                marginBottom: '4px',
              }}
            >
              District
            </label>
            <select
              id="district"
              name="district"
              value={form.district}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #cbd5e0',
                borderRadius: '6px',
                outline: 'none',
                transition: 'border-color 0.15s ease-in-out',
                backgroundColor: '#fff', // Ensure consistent background
              }}
              onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
              onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
            >
              <option value="">Select District</option>
              {districts.map((district) => (
                <option key={district.value} value={district.value}>
                  {district.label}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label
              htmlFor="zone"
              style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4a5568',
                marginBottom: '4px',
              }}
            >
              Zone
            </label>
            <input
              id="zone"
              type="text"
              name="zone"
              placeholder="Zone (auto-filled)"
              value={form.zone}
              readOnly // Make it read-only as it's auto-filled
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #cbd5e0',
                borderRadius: '6px',
                outline: 'none',
                backgroundColor: '#e2e8f0', // Grey out for read-only
                color: '#4a5568',
              }}
            />
          </div>

          <div>
            <label
              htmlFor="report_date" // Changed name to match Django model
              style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4a5568',
                marginBottom: '4px',
              }}
            >
              Date
            </label>
            <input
              id="report_date"
              type="date"
              name="report_date" // Changed name to match Django model
              value={form.report_date}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #cbd5e0',
                borderRadius: '6px',
                outline: 'none',
                transition: 'border-color 0.15s ease-in-out',
              }}
              onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
              onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
            />
          </div>
          <div>
            <label
              htmlFor="reporting_week" // Changed name to match Django model
              style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4a5568',
                marginBottom: '4px',
              }}
            >
              Reporting Week
            </label>
            <select
              id="reporting_week"
              name="reporting_week" // Changed name to match Django model
              value={form.reporting_week}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #cbd5e0',
                borderRadius: '6px',
                outline: 'none',
                transition: 'border-color 0.15s ease-in-out',
                backgroundColor: '#fff',
              }}
              onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
              onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
            >
              <option value="">Select Week</option>
              {weeks.map((week) => (
                <option key={week} value={`Week ${week}`}>
                  Week {week}
                </option>
              ))}
            </select>
          </div>
        </div>
      </section>

      {/* Section 2: Community Engagement Summary */}
      <section
        style={{
          backgroundColor: '#f8fafc',
          padding: '24px',
          borderRadius: '8px',
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
          border: '1px solid #f1f5f9',
        }}
      >
        <h2
          style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#2d3748',
            marginBottom: '20px',
            paddingBottom: '12px',
            borderBottom: '1px solid #cbd5e0',
          }}
        >
          Section 2: Community Engagement Summary
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label
              htmlFor="communities_visited" // Changed name to match Django model
              style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4a5568',
                marginBottom: '4px',
              }}
            >
              Communities Visited
            </label>
            <textarea
              id="communities_visited"
              name="communities_visited" // Changed name to match Django model
              placeholder="List all communities visited, separated by commas or new lines."
              value={form.communities_visited}
              onChange={handleChange}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #cbd5e0',
                borderRadius: '6px',
                outline: 'none',
                minHeight: '96px', // h-24
                resize: 'vertical',
                transition: 'border-color 0.15s ease-in-out',
              }}
              onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
              onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
            />
          </div>
          <div>
            <label
              htmlFor="stakeholders_engaged" // Changed name to match Django model
              style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4a5568',
                marginBottom: '4px',
              }}
            >
              Key Stakeholders Engaged
            </label>
            <textarea
              id="stakeholders_engaged"
              name="stakeholders_engaged" // Changed name to match Django model
              placeholder="Describe who you engaged with (e.g., community leaders, youth groups, local authorities)."
              value={form.stakeholders_engaged}
              onChange={handleChange}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #cbd5e0',
                borderRadius: '6px',
                outline: 'none',
                minHeight: '96px', // h-24
                resize: 'vertical',
                transition: 'border-color 0.15s ease-in-out',
              }}
              onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
              onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
            />
          </div>
          <div>
            <label
              htmlFor="community_feedback" // Changed name to match Django model
              style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4a5568',
                marginBottom: '4px',
              }}
            >
              Summary of Community Feedback
            </label>
            <textarea
              id="community_feedback"
              name="community_feedback" // Changed name to match Django model
              placeholder="Summarize key feedback, insights, and concerns from the community."
              value={form.community_feedback}
              onChange={handleChange}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #cbd5e0',
                borderRadius: '6px',
                outline: 'none',
                minHeight: '128px', // h-32
                resize: 'vertical',
                transition: 'border-color 0.15s ease-in-out',
              }}
              onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
              onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
            />
          </div>
        </div>
      </section>

      {/* Section 3: Scouted Innovations */}
      <section
        style={{
          backgroundColor: '#f8fafc',
          padding: '24px',
          borderRadius: '8px',
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
          border: '1px solid #f1f5f9',
        }}
      >
        <h2
          style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#2d3748',
            marginBottom: '20px',
            paddingBottom: '12px',
            borderBottom: '1px solid #cbd5e0',
          }}
        >
          Section 3: Scouted Innovations
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label
              htmlFor="number_of_innovators" // Changed name to match Django model
              style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4a5568',
                marginBottom: '4px',
              }}
            >
              Number of Innovators Identified
            </label>
            <input
              id="number_of_innovators"
              type="number"
              min="0"
              name="number_of_innovators" // Changed name to match Django model
              placeholder="Enter total number (e.g., 5)"
              value={form.number_of_innovators}
              onChange={handleChange}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #cbd5e0',
                borderRadius: '6px',
                outline: 'none',
                transition: 'border-color 0.15s ease-in-out',
              }}
              onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
              onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
            />
          </div>
          <div>
            <label
              htmlFor="innovations"
              style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4a5568',
                marginBottom: '4px',
              }}
            >
              List of Innovations
            </label>
            <textarea
              id="innovations"
              name="innovations"
              placeholder="Provide a brief description of each innovation found, including name, location, and potential impact."
              value={form.innovations}
              onChange={handleChange}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #cbd5e0',
                borderRadius: '6px',
                outline: 'none',
                minHeight: '128px', // h-32
                resize: 'vertical',
                transition: 'border-color 0.15s ease-in-out',
              }}
              onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
              onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
            />
          </div>
          {/* New fields: file and innovator_phone */}
         
        </div>
      </section>

      {/* Section 4: Disaggregated Scouting Metrics */}
      <section
        style={{
          backgroundColor: '#f8fafc',
          padding: '24px',
          borderRadius: '8px',
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
          border: '1px solid #f1f5f9',
        }}
      >
        <h2
          style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#2d3748',
            marginBottom: '20px',
            paddingBottom: '12px',
            borderBottom: '1px solid #cbd5e0',
          }}
        >
          Section 4: Disaggregated Scouting Metrics
        </h2>
        <div
          style={{
            overflowX: 'auto',
            borderRadius: '8px',
            border: '1px solid #cbd5e0',
            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
          }}
        >
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              borderSpacing: '0',
            }}
          >
            <thead
              style={{
                backgroundColor: '#2563eb', // blue-600
                color: '#fff', // text-white
              }}
            >
              <tr>
                <th
                  style={{
                    padding: '12px 24px', // px-6 py-3
                    textAlign: 'left', // text-left
                    fontSize: '12px', // text-xs
                    fontWeight: '500', // font-medium
                    textTransform: 'uppercase', // uppercase
                    letterSpacing: '0.05em', // tracking-wider
                  }}
                >
                  Category
                </th>
                <th
                  style={{
                    padding: '12px 24px',
                    textAlign: 'left',
                    fontSize: '12px',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                  }}
                >
                  Number of Innovators
                </th>
                <th
                  style={{
                    padding: '12px 24px',
                    textAlign: 'left',
                    fontSize: '12px',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                  }}
                >
                  Validated (Y/N)
                </th>
                <th
                  style={{
                    padding: '12px 24px',
                    textAlign: 'left',
                    fontSize: '12px',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                  }}
                >
                  Notes
                </th>
              </tr>
            </thead>
            <tbody style={{ backgroundColor: '#fff', borderTop: '1px solid #e2e8f0' }}>
              {['male', 'female', 'pwd'].map((cat, index) => (
                <tr key={cat} style={{ borderBottom: '1px solid #e2e8f0', backgroundColor: index % 2 === 0 ? '#fff' : '#f8fafc' /* odd:bg-white even:bg-gray-50 */ }}>
                  <td
                    style={{
                      padding: '16px 24px', // px-6 py-4
                      whiteSpace: 'nowrap', // whitespace-nowrap
                      fontSize: '14px', // text-sm
                      fontWeight: '500', // font-medium
                      color: '#1a202c', // text-gray-900
                    }}
                  >
                    {cat.charAt(0).toUpperCase() + cat.slice(1)} Innovators
                  </td>
                  <td
                    style={{
                      padding: '16px 24px',
                      whiteSpace: 'nowrap',
                      fontSize: '14px',
                      color: '#2d3748', // text-gray-800
                    }}
                  >
                    <input
                      type="number"
                      min="0"
                      style={{
                        width: '96px', // w-24
                        padding: '8px', // p-2
                        border: '1px solid #cbd5e0',
                        borderRadius: '6px',
                        outline: 'none',
                        transition: 'border-color 0.15s ease-in-out',
                      }}
                      value={form[`${cat}_innovators_count`]} // Use flattened field
                      onChange={(e) => handleMetricChange(cat, 'count', e.target.value)}
                      onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
                      onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
                    />
                  </td>
                  <td
                    style={{
                      padding: '16px 24px',
                      whiteSpace: 'nowrap',
                      fontSize: '14px',
                      color: '#2d3748',
                    }}
                  >
                    <select
                      style={{
                        width: '96px', // w-24
                        padding: '8px',
                        border: '1px solid #cbd5e0',
                        borderRadius: '6px',
                        outline: 'none',
                        transition: 'border-color 0.15s ease-in-out',
                      }}
                      value={form[`${cat}_innovators_validated`]} // Use flattened field
                      onChange={(e) => handleMetricChange(cat, 'validated', e.target.value)}
                      onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
                      onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </td>
                  <td
                    style={{
                      padding: '16px 24px',
                      whiteSpace: 'nowrap',
                      fontSize: '14px',
                      color: '#2d3748',
                    }}
                  >
                    <input
                      type="text"
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #cbd5e0',
                        borderRadius: '6px',
                        outline: 'none',
                        transition: 'border-color 0.15s ease-in-out',
                      }}
                      placeholder="Add notes"
                      value={form[`${cat}_innovators_notes`]} // Use flattened field
                      onChange={(e) => handleMetricChange(cat, 'notes', e.target.value)}
                      onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
                      onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Section 5: Challenges and Recommendations */}
      <section
        style={{
          backgroundColor: '#f8fafc',
          padding: '24px',
          borderRadius: '8px',
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
          border: '1px solid #f1f5f9',
        }}
      >
        <h2
          style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#2d3748',
            marginBottom: '20px',
            paddingBottom: '12px',
            borderBottom: '1px solid #cbd5e0',
          }}
        >
          Section 5: Challenges and Recommendations
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label
              htmlFor="challenges_encountered" // Changed name to match Django model
              style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4a5568',
                marginBottom: '4px',
              }}
            >
              Challenges Encountered
            </label>
            <textarea
              id="challenges_encountered"
              name="challenges_encountered" // Changed name to match Django model
              placeholder="Describe any difficulties or obstacles faced during your scouting activities."
              value={form.challenges_encountered}
              onChange={handleChange}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #cbd5e0',
                borderRadius: '6px',
                outline: 'none',
                minHeight: '128px', // h-32
                resize: 'vertical',
                transition: 'border-color 0.15s ease-in-out',
              }}
              onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
              onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
            />
          </div>
          <div>
            <label
              htmlFor="suggestions_recommendations" // Changed name to match Django model
              style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4a5568',
                marginBottom: '4px',
              }}
            >
              Suggestions or Recommendations
            </label>
            <textarea
              id="suggestions_recommendations"
              name="suggestions_recommendations" // Changed name to match Django model
              placeholder="Provide actionable suggestions for improving future scouting efforts or addressing identified challenges."
              value={form.suggestions_recommendations}
              onChange={handleChange}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #cbd5e0',
                borderRadius: '6px',
                outline: 'none',
                minHeight: '128px', // h-32
                resize: 'vertical',
                transition: 'border-color 0.15s ease-in-out',
              }}
              onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
              onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
            />
          </div>
        </div>
      </section>

      {/* Section 6: Learnings */}
      <section
        style={{
          backgroundColor: '#f8fafc',
          padding: '24px',
          borderRadius: '8px',
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
          border: '1px solid #f1f5f9',
        }}
      >
        <h2
          style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#2d3748',
            marginBottom: '20px',
            paddingBottom: '12px',
            borderBottom: '1px solid #cbd5e0',
          }}
        >
          Section 6: Learnings
        </h2>
        <div>
          <label
            htmlFor="learnings_reflections" // Changed name to match Django model
            style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: '#4a5568',
              marginBottom: '4px',
            }}
          >
            Reflections and Learnings
          </label>
          <textarea
            id="learnings_reflections"
            name="learnings_reflections" // Changed name to match Django model
            placeholder="Reflect on key insights gained, new knowledge acquired, or personal growth experienced during the reporting period."
            value={form.learnings_reflections}
            onChange={handleChange}
            style={{
              width: '100%',
              padding: '12px',
              border: '1px solid #cbd5e0',
              borderRadius: '6px',
              outline: 'none',
              minHeight: '128px', // h-32
              resize: 'vertical',
              transition: 'border-color 0.15s ease-in-out',
            }}
            onFocus={(e) => (e.target.style.borderColor = '#3b82f6')}
            onBlur={(e) => (e.target.style.borderColor = '#cbd5e0')}
          />
        </div>
      </section>

      {/* Submit Button */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '32px', // mt-8
        }}
      >
        <button
          type="submit"
          style={{
            backgroundColor: '#2563eb', // blue-700
            color: '#fff', // text-white
            fontWeight: '800', // font-extrabold
            padding: '12px 32px', // py-3 px-8
            borderRadius: '9999px', // rounded-full
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', // shadow-lg
            transition: 'background-color 0.3s ease-in-out, transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out', // transition duration-300 ease-in-out transform
            border: 'none',
            cursor: 'pointer',
            outline: 'none', // focus:outline-none
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#1d4ed8'; // blue-800
            e.currentTarget.style.transform = 'scale(1.05)'; // hover:scale-105
            e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'; // larger shadow on hover
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#2563eb'; // blue-700
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
          }}
          onFocus={(e) => {
            e.currentTarget.style.boxShadow = '0 0 0 4px rgba(59, 130, 246, 0.5), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'; // focus:ring-4 focus:ring-blue-300 focus:ring-opacity-75
          }}
          onBlur={(e) => {
            e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
          }}
        >
          Submit Report
        </button>
      </div>
    </form>
  );
}
